package com.jingfangpai.medicalRecord.model

import com.jingfangpai.common.orm.mapping.MedicalRecord
import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordDetail: MedicalRecord() {
    var symptoms:Set<MedicalRecordSignSymptomDto> = setOf()
}